<form
  [formGroup]="crownSectionForm"
  class="crown-section rx-app-flex-container-column"
  [class.read-only]="isReadOnly || (isCrownSectionDisabled$ | async)"
>
  <div class="crown-section__main rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--justify-center">
    <div
      class="left-content rx-app-flex-container-row rx-app-flex-container-row--wrap rx-app-flex-container-row--justify-space-between"
    >
        <rx-select
            *ngIf="specifications?.length"
            class="rx-app-flex--full"
            [id]="'specification'"
            [label]="'ToothEditor.Specification' | translate"
            [isRequired]="(shouldValidateForSend$ | async) ?? false"
            [isCancellable]="(shouldValidateForSend$ | async) === false"
            [isDisabled]="(isCrownSectionDisabled$ | async) || isReadOnly"
            [formControl]="specificationControl"
            [options]="specifications"
            (cancelSelectionEvent)="handleCancelSpecification()"
            name="specificationControl"
        ></rx-select>
        <rx-favorite-selector
            class="rx-app-flex--full"
            [id]="'material'"
            [label]="'ToothEditor.Material' | translate"
            [isRequired]="(shouldValidateForSend$ | async) ?? false"
            [isCancellable]="(shouldValidateForSend$ | async) === false"
            [formControl]="materialControl"
            [isReadOnly]="isReadOnly"
            [isDisabled]="(isCrownSectionDisabled$ | async) || (specifications?.length && !specificationControl.value) ||
            !this.materialOptions?.length"
            [options]="materialOptions"
            [favoriteName]="favoriteMaterial"
            name="materialControl"
			[enableSimpleMode]="isNotDoctor$ | async"
            (cancelSelection)="handleCancelMaterial($event)"
        ></rx-favorite-selector>
        <rx-pontic-selector
            class="crown-section__pontic"
            *ngIf="isPonticIndicationSelected$ | async"
            [formControl]="ponticDesignControl"
            [isReadonly]="isReadOnly"
            [rxIsDisabled]="isCrownSectionDisabled$ | async"
            [options]="ponticDesigns"
            name="ponticDesignControl"
        ></rx-pontic-selector>
    </div>
    <div class="right-content rx-app-flex-container-column">
      <rx-select
        [id]="'shade-system'"
        [label]="'ToothEditor.ShadeSystem' | translate"
        [isDisabled]="isShadeDisabled || isReadOnly"
        [isCancellable]="false"
        [formControl]="shadeSystemControl"
        [options]="shadeSystemOptions"
        name="shadeSystemControl"
      ></rx-select>
      <rx-select
        *ngIf="!isOtherShadeSystemSelected"
          [id]="'body'"
          [label]="'ToothEditor.Body' | translate"
          [isRequired]="(shouldValidateForSend$ | async) && materialOption?.BodyShadeMandatory"
          [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.BodyShadeMandatory"
          [isDisabled]="isShadeDisabled || isReadOnly"
          [formControl]="bodyControlAsIdName"
          [options]="incisalBodyGingivalOptions"
		  (cancelSelectionEvent)="handleCancelSelection(bodyControlAsIdName)"
		  name="bodyControl"
      ></rx-select>
      <div *ngIf="isOtherShadeSystemSelected">
          <rx-text-input
              [label]="'ToothEditor.Body' | translate"
              [formControl]="bodyControlAsAString"
              [isDisabled]="isShadeDisabled || isReadOnly"
              [isRequired]="materialOption?.BodyShadeMandatory && (shouldValidateForSend$ | async)"
              [maxlength]="maxInputLengthForOtherShadeSystem"
              [name]="'bodyControl'"
          >

          </rx-text-input>
<!--          <mat-form-field>
              <mat-label>{{ 'ToothEditor.Body' | translate }}</mat-label>
              <input
                  matInput
                  [maxlength]="maxInputLengthForOtherShadeSystem"
                  [formControl]="bodyControl"
                  [rxIsDisabled]="isShadeDisabled"
                  [readonly]="isReadOnly"
                  [required]="materialOption?.BodyShadeMandatory && (shouldValidateForSend$ | async)"
                  autocomplete="off"
                  name="bodyControl"
              />
          </mat-form-field>-->
      </div>
    </div>
</div>
<mat-expansion-panel id="additional-info-expansion-panel"
  [(expanded)]="expandAdditionalInfo"
  togglePosition="before"
  class="additional-info-expansion-panel">
  <mat-expansion-panel-header class="rx-expansion-header">
    <mat-panel-title id="additional-info-expansion-panel-title">
      {{ 'ToothEditor.AdditionalInfo' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="rx-app-flex-container-row">
    <div
      class="left-content rx-app-flex-container-row rx-app-flex-container-row--wrap rx-app-flex-container-row--justify-space-between"
    >
      <rx-select
          class="crown-section__design-select"
        [id]="'preparation-design-buccal'"
        [label]="('ToothEditor.PreparationDesign' | translate) + '- ' + ('ToothEditor.Buccal' | translate)"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.PrepDesignMandatory"
        [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.PrepDesignMandatory"
        [formControl]="preparationDesignBuccalControl"
        [isDisabled]="!materialOption?.PrepDesignVisible || isReadOnly"
        [options]="preparationDesignOptions"
        (cancelSelectionEvent)="handleCancelSelection(preparationDesignBuccalControl)"
        name="preparationDesignBuccalControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'preparation-design-lingual'"
        [label]="('ToothEditor.PreparationDesign' | translate) + '- ' + ('ToothEditor.Lingual' | translate)"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.PrepDesignMandatory"
        [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.PrepDesignMandatory"
        [formControl]="preparationDesignLingualControl"
        [isDisabled]="!materialOption?.PrepDesignVisible || isReadOnly"
        [options]="preparationDesignOptions"
  	  (cancelSelectionEvent)="handleCancelSelection(preparationDesignLingualControl)"
        name="preparationDesignLingualControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'margin-design-buccal'"
        [label]="('ToothEditor.MarginDesign' | translate) + '- ' + ('ToothEditor.Buccal' | translate)"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.MarginDesignMandatory"
        [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.MarginDesignMandatory"
        [formControl]="marginDesignBuccalControl"
        [isDisabled]="!materialOption?.MarginDesignVisible || isReadOnly"
        [options]="marginDesignOptions"
  	  (cancelSelectionEvent)="handleCancelSelection(marginDesignBuccalControl)"
        name="marginDesignBuccalControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'margin-design-lingual'"
        [label]="('ToothEditor.MarginDesign' | translate) + '- ' + ('ToothEditor.Lingual' | translate)"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.MarginDesignMandatory"
        [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.MarginDesignMandatory"
        [formControl]="marginDesignLingualControl"
        [isDisabled]="!materialOption?.MarginDesignVisible || isReadOnly"
        [options]="marginDesignOptions"
        (cancelSelectionEvent)="handleCancelSelection(marginDesignLingualControl)"
        name="marginDesignLingualControl"
      ></rx-select>
    </div>
    <div class="right-content rx-app-flex-container-column">
        <ng-container *ngIf="!isOtherShadeSystemSelected">
          <rx-select
              [id]="'incisal'"
              [label]="'ToothEditor.Incisal' | translate"
              [isDisabled]="isShadeDisabled || isReadOnly"
              [isCancellable]="true"
              [formControl]="incisalControlAsIdName"
              [options]="incisalBodyGingivalOptions"
              (cancelSelectionEvent)="handleCancelSelection(incisalControlAsIdName)"
              name="incisalControl"
          ></rx-select>
          <rx-select
              [id]="'gingival'"
              [label]="'ToothEditor.Gingival' | translate"
              [isDisabled]="isShadeDisabled || isReadOnly"
              [isCancellable]="true"
              [formControl]="gingivalControlAsIdName"
              [options]="incisalBodyGingivalOptions"
  			(cancelSelectionEvent)="handleCancelSelection(gingivalControlAsIdName)"
  			name="gingivalControl"
          ></rx-select>
        </ng-container>
        <ng-container *ngIf="isOtherShadeSystemSelected">
          <div>
              <rx-text-input
                  [label]="'ToothEditor.Incisal' | translate"
                  [formControl]="incisalControl"
                  [isDisabled]="isShadeDisabled || isReadOnly"
                  [maxlength]="maxInputLengthForOtherShadeSystem"
                  autocomplete="off"
                  [name]="'incisalControl'"
              ></rx-text-input>
          </div>
          <div>
              <rx-text-input
                  [label]="'ToothEditor.Gingival' | translate"
                  [formControl]="gingivalControl"
                  [isDisabled]="isShadeDisabled || isReadOnly"
                  [maxlength]="maxInputLengthForOtherShadeSystem"
                  autocomplete="off"
                  [name]="'gingivalControl'"
              ></rx-text-input>
          </div>
        </ng-container>
        <rx-select
          [id]="'stump-shade'"
          [label]="'ToothEditor.StumpShade' | translate"
          [isRequired]="(shouldValidateForSend$ | async) && materialOption?.StumpShadeMandatory"
          [isCancellable]="(shouldValidateForSend$ | async) === false || !materialOption?.StumpShadeMandatory"
          [isDisabled]="!materialOption?.StumpShadeVisible || isReadOnly"
          [formControl]="stumpShadeControl"
          [options]="stumpShadeOptions"
          (cancelSelectionEvent)="handleCancelSelection(stumpShadeControl)"
          name="stumpShadeControl"
      ></rx-select>
    </div>
  </div>
</mat-expansion-panel>

</form>
